


















import Vue from "vue";
import InformationCard from "@/features/information/components/information-card.vue";
import InformationParentRow from "@/features/information/components/information-parent-row.vue";

export default Vue.extend({
  props: {
    parents: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    InformationCard,
    InformationParentRow,
  },
});
